import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_MULTIPLE_QRCODE_FLYERS = defineFcm('starfish_multiple_qrcode_flyers')
	.asBoolean()
	.withDefault(false)
	.toConfig();
